/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], () => {
	'use strict';


	class BaseFeature {

		constructor(widgetApi, dashboardApi) {
			this.widgetApi = widgetApi;
			this.dashboardApi = dashboardApi;
			console.debug('feature created');
		}

		getAPI(){
			return {
				testAPI: () => {
					console.debug('hello from ' + this.widgetApi.getId());
				}
			};
		}
	}

	return BaseFeature;
});
